<div class="row expanded books-dashboard-top-charts" style="height: 460px !important;">
  <div class="column medium-12 expanded charts-main">
    <div *ngIf="hasGraphData" style="min-width: 300px;height:400px;">
      <highcharts-chart [Highcharts]="Highcharts" [options]="groupedTimelineChartOptions"
                        style="width: 100%; height: 400px; display: block"></highcharts-chart>
    </div>
  </div>
</div>

